import "./facility_page.css";

function FacilityPage() {
  const words = `저희 시니어사랑방문요양센터는

2015년부터 함께 일해오신 경력직 요양보호사 선생님들, 사회복지사 선생님들과 함께
어르신들이 보다 좋은 삶을 영위할 수 있도록 함께 노력하는 방문요양센터입니다.

2023년 새롭게 이름을 시니어사랑방문요양센터로 등록하고 설치 신고를 2023년 5월 1일자로 마쳤습니다.

천안지역 어디든 필요하신 가정에 요양보호사선생님을 매칭시키고
부양 가족분들의 노고를 조금이나마 덜어드리고자 노력하는 기관입니다.

장기요양서비스에 관심이 있으신 분들은
천안 서북구 월봉7길49, 효명리치빌223호로 방문 또는
전화 041-575-7651로 문의 주시면 언제든 친절히 상담 도와드리겠습니다.

장기요양신청부터 직접적인 서비스, 지속적인 모니터링으로 안심하고 맡기실 수 있는 기관!

시니어사랑방문요양센터와 함께 동행하시길 바랍니다.`;

  return (
    <div className="facility_page">
      <div className="facility_container">{words}</div>
    </div>
  );
}

export default FacilityPage;
